import { render, staticRenderFns } from "./EditNumberDialog.vue?vue&type=template&id=6dfaae16&"
import script from "./EditNumberDialog.vue?vue&type=script&lang=ts&"
export * from "./EditNumberDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports